<!-- ═══════════════ Accept referral (shared referral-dialog look) ═══════════════
     fixed header · ONE scrolling body · sticky action bar -->
<div class="ar-dialog">

  <header class="ar-head">
    <div class="ar-head-ic ok"><mat-icon>task_alt</mat-icon></div>
    <div class="ar-head-txt">
      <h2>Accept referral</h2>
      <p><b>{{ personName }}</b><span class="ar-dot">·</span>{{ data?.selectedRecord?.isExternal ? 'notify the hospital and your contacts' : 'notify your contacts' }}</p>
    </div>
    <button mat-icon-button class="ar-close" (click)="close()" matTooltip="Close"><mat-icon>close</mat-icon></button>
  </header>

  <mat-dialog-content class="ar-body">

    <!-- Two columns (2026-09-28): LEFT = status notes + who is this for + resident office · RIGHT = notification email.
         Single column (old width) when there is no facility picker (internal / single-facility rows). -->
    <div class="ar-cols" [class.single]="!providerOptions.length">
    <div class="ar-col">

    <!-- Current hospital-portal response (noticeable — the user is about to change it) -->
    <div class="ar-note history" *ngIf="data?.selectedRecord?.isExternal && data?.selectedRecord?.sourceResponseName">
      <mat-icon>history</mat-icon>
      <span>Previously sent <b>{{ data.selectedRecord.sourceResponseName }}</b><ng-container *ngIf="data.selectedRecord.sourceResponseBy"> by <b>{{ data.selectedRecord.sourceResponseBy }}</b></ng-container></span>
    </div>
    <!-- Internal / single-facility rows: the referral's current status, so the user knows what they are changing -->
    <div class="ar-note history" *ngIf="!data?.selectedRecord?.sourceResponseName && !providerOptions.length">
      <mat-icon>history</mat-icon>
      <span>Current status <b>{{ rowState() }}</b></span>
    </div>

    <!-- Sync OFF: accepting will update Flowtrics only — say so BEFORE they confirm -->
    <div class="ar-note warn" *ngIf="data?.selectedRecord?.isExternal && data?.portalSyncOff">
      <mat-icon>sync_disabled</mat-icon>
      <span><b>Your CarePort sync is off — this Accept will update Flowtrics only.</b>
        The resident is created and emails go out as usual, but <b>the hospital will NOT be notified</b>.
        To notify them, enable Sync in <b>My Profile → External Referral Sources</b> first.</span>
    </div>

    <!-- ── Who is this Accept for (multi-recipient portal referrals) ── -->
    <section class="ar-section" *ngIf="providerOptions.length">
      <div class="ar-sec-head">
        <mat-icon class="ar-sec-ic">fact_check</mat-icon>
        <h3>Who is this Accept for?</h3>
        <span class="ar-sec-sub">this referral went to {{ providerOptions.length }} facilities</span>
      </div>
      <div class="ar-pick">
        <label class="ar-pick-item" *ngFor="let f of providerOptions"
               [class.checked]="selectedProviderKeys[provKey(f)]"
               [class.disabled]="providerDisabled(f)"
               [class.already]="alreadyIn(f)"
               [matTooltip]="providerHint(f)">
          <input type="checkbox" [checked]="selectedProviderKeys[provKey(f)]"
                 [disabled]="providerDisabled(f)"
                 (change)="onProviderToggle(f, $any($event.target).checked)" />
          <span class="ar-pick-txt">
            <span class="ar-pick-row">
              <span class="ar-pick-nm">{{ f.facilityName }}</span>
              <span class="ar-pick-mine" *ngIf="f.isMine">this office</span>
              <span class="ar-pick-already" *ngIf="alreadyIn(f)">already {{ actionLabel() }}</span>
            </span>
            <!-- current state of this facility: who · when -->
            <span class="ar-pick-st">{{ stateLine(f) || 'No response yet' }}</span>
          </span>
        </label>
      </div>
      <div class="ar-pick-warn" *ngIf="!canSubmitProviders() && !allAlready()">
        <mat-icon>error_outline</mat-icon> Select at least one facility to continue.
      </div>
      <!-- Same response again: those facilities stay unselectable and the user is told why -->
      <div class="ar-note warn" style="margin-top:10px" *ngIf="alreadyList().length && !allAlready()">
        <mat-icon>info_outline</mat-icon>
        <span><b>Already {{ actionLabel() }}:</b> {{ alreadyText() }}. These cannot be selected again — the hospital already has that answer for them.</span>
      </div>
      <div class="ar-note danger" style="margin-top:10px" *ngIf="allAlready()">
        <mat-icon>block</mat-icon>
        <span>Every facility on this referral is already <b>{{ actionLabel() }}</b> — there is nothing new to send.</span>
      </div>
      <!-- Accept sent ONLY on behalf of other facilities: the hospital is told for THEM -->
      <div class="ar-note info" style="margin-top:12px" *ngIf="onBehalfOfOthersOnly()">
        <mat-icon>info_outline</mat-icon>
        <span>Accepting on behalf of <b>{{ selectedProviders()[0]?.facilityName }}</b><ng-container *ngIf="selectedProviders().length > 1"> and {{ selectedProviders().length - 1 }} more</ng-container>
          — the hospital is notified for that facility. <b>No resident is created in this office</b>;
          <ng-container *ngIf="canCreateResident(); else noResHere"><b>Accept &amp; Create Resident</b> creates it in <b>{{ residentOfficeName() }}</b>.</ng-container>
          <ng-template #noResHere>use <b>Accept</b> and create the resident later from that office's Accepted list.</ng-template></span>
      </div>
    </section>

    <!-- ── Resident: WHICH office "Accept & Create Resident" creates it in (multi-facility only) ── -->
    <section class="ar-section" *ngIf="mfDeferred && !data?.selectedRecord?.coreID && providerOptions.length && selectedProviders().length">
      <div class="ar-sec-head">
        <mat-icon class="ar-sec-ic">person_add</mat-icon>
        <h3>Resident record</h3>
        <span class="ar-sec-sub">used by <b>Accept &amp; Create Resident</b> below</span>
      </div>
      <ng-container *ngIf="canCreateResident()">
        <div class="ar-office-row" *ngIf="residentOffices().length">
          <mat-icon>business</mat-icon>
          <label for="residentOffice">Create the resident in</label>
          <select id="residentOffice" class="ar-select" [(ngModel)]="residentOfficeID">
            <option *ngFor="let o of residentOffices()" [ngValue]="o.officeID">{{ o.officeName }}<ng-container *ngIf="o.isThisOffice"> (this office)</ng-container> — {{ o.facilityName }}</option>
          </select>
        </div>
        <div class="ar-note info" style="margin-top:10px" *ngIf="residentOfficeID && residentOfficeID !== myOfficeID">
          <mat-icon>info_outline</mat-icon>
          <span>The resident will be created in <b>{{ residentOfficeName() }}</b> and linked to <b>{{ residentFacilityName() }}</b>. It will not appear in this office's residents.</span>
        </div>
        <div class="ar-note warn" style="margin-top:10px" *ngIf="residentOfficesMissing().length">
          <mat-icon>warning_amber</mat-icon>
          <span>No office is available for <b>{{ residentOfficesMissing()[0]?.facilityName }}</b><ng-container *ngIf="residentOfficesMissing().length > 1"> and {{ residentOfficesMissing().length - 1 }} more</ng-container>
            (not mapped, or you have no access) — its resident can be created later from that office's Accepted list.</span>
        </div>
      </ng-container>
      <div class="ar-note warn" *ngIf="!canCreateResident()">
        <mat-icon>warning_amber</mat-icon>
        <span>You have no access to the office of the selected facility, so no resident can be created here — use <b>Accept</b>; the resident can be created later from that office's Accepted list.</span>
      </div>
    </section>

    </div>
    <div class="ar-col">

    <!-- ── Notification email ── -->
    <section class="ar-section">
      <div class="ar-sec-head">
        <mat-icon class="ar-sec-ic">mail_outline</mat-icon>
        <h3>Notification email</h3>
        <span class="ar-sec-sub">optional — sent to the addresses you add</span>
      </div>
      <div class="ar-lead">
        <mat-icon>mark_email_read</mat-icon>
        <span>We are pleased to inform you that <b>{{ personName }}</b> has been officially <b>accepted</b>.</span>
      </div>

      <mat-form-field appearance="outline" class="ar-field">
        <mat-label>Message</mat-label>
        <textarea matInput placeholder="Add a message to the email (optional)" rows="3"
                  cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" [(ngModel)]="message"></textarea>
      </mat-form-field>

      <div class="ar-email-row">
        <mat-form-field appearance="outline" class="ar-field">
          <mat-label>Email</mat-label>
          <mat-icon matPrefix>alternate_email</mat-icon>
          <input matInput maxlength="200" placeholder="name@example.com" [(value)]="emailAssigned"
                 (input)="emailCheck($event.target.value)" (keydown.enter)="addEmailButtonShow && addEmail()" />
        </mat-form-field>
        <button mat-flat-button color="primary" class="ar-add" [disabled]="!addEmailButtonShow" (click)="addEmail()">
          <mat-icon>add</mat-icon> Add
        </button>
      </div>

      <ul class="ar-chips" *ngIf="addUpdateParticipantList?.length">
        <li *ngFor="let ass of addUpdateParticipantList">
          <span class="ar-chip-av">
            <img *ngIf="ass.img" [src]="ass.img" alt="">
            <ng-container *ngIf="!ass.img">{{ ass.shortName }}</ng-container>
          </span>
          <span class="ar-chip-txt"><b>{{ ass.name || ass.email }}</b><small *ngIf="ass.name">{{ ass.email }}</small></span>
          <button mat-icon-button class="ar-chip-x" matTooltip="Remove" (click)="removeParticipant(ass)"><mat-icon>close</mat-icon></button>
        </li>
      </ul>
    </section>

    </div>
    </div>
  </mat-dialog-content>

  <footer class="ar-actions">
    <button mat-button class="ar-cancel" (click)="close()">Cancel</button>
    <span class="ar-spacer"></span>
    <!-- Accept WITHOUT a resident (create it later from the Accepted list) -->
    <button mat-flat-button color="primary" class="ar-primary" type="submit" (click)="acceptAndSendMail(false)"
            [disabled]="!canSubmitProviders() || spinner"
            [matTooltip]="canCreateResident() ? 'Accept now; the resident can be created later from the Accepted list' : ''">
      <mat-spinner *ngIf="spinner" diameter="18"></mat-spinner>
      <mat-icon *ngIf="!spinner">check_circle</mat-icon>
      {{ textButton }}
    </button>
    <!-- Accept AND open the resident form right after (in the chosen office for multi-facility rows) -->
    <button mat-flat-button color="primary" class="ar-primary" type="button" *ngIf="canCreateResident()" (click)="acceptAndSendMail(true)"
            [disabled]="!canSubmitProviders() || spinner"
            [matTooltip]="providerOptions.length && residentOfficeID && residentOfficeID !== myOfficeID ? ('Creates the resident in ' + residentOfficeName()) : 'Accept and open the resident form'">
      <mat-icon>person_add</mat-icon>
      Accept &amp; Create Resident
    </button>
  </footer>

</div>

<app-loader></app-loader>
